import styled from 'styled-components';

import { RouterButton } from 'components/Button/RouterButton';
import { TrackedLink } from 'components/Link';
import { NavLink } from 'components/RouterLink';
import { colors, cssBreakpoints, gutterWidth, transition } from 'theme/theme';

const pageHeaderTopSectionHeightVar = '--page-header-top-section-height';
const pageHeaderMobileLinksHeight = 64;

export const PageHeaderHolder = styled.div`
  display: flex;
  flex-direction: column;

  position: sticky;
  top: 0;
  left: 0;
  z-index: 101;

  font-size: 15px;
  line-height: normal;

  background: ${colors.white};
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.075);

  @media print {
    display: none;
  }
`;

export const PageHeaderTopSectionHolder = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 ${gutterWidth / 2}px;
  height: var(${pageHeaderTopSectionHeightVar});
  position: relative;

  @media screen and (max-width: ${cssBreakpoints.mdDown}) {
    ${pageHeaderTopSectionHeightVar}: 60px;
  }

  @media screen and (min-width: ${cssBreakpoints.mdUp}) {
    ${pageHeaderTopSectionHeightVar}: 58px;
  }
`;

export const PageHeaderLeft = styled.div`
  display: flex;
  align-items: center;
`;

export const PageHeaderLinksHolder = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  @media (max-width: ${cssBreakpoints.mdDown}) {
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    height: ${pageHeaderMobileLinksHeight}px;
    border-top: 1px solid ${colors.selectionGrey};
    justify-content: space-evenly;
  }
`;

export const PageHeaderDesktopDonateNavLink = styled(NavLink)`
  padding: 0 16px;
  height: 38px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  transition: ${transition};

  &:hover {
    background: ${colors.calloutGrey};
  }

  &:not([aria-current]) {
    text-decoration: none;
  }

  @media (max-width: ${cssBreakpoints.mdDown}) {
    display: none;
  }
`;

const pageHeaderRightDesktopGap = 16;
export const PageHeaderRight = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;

  @media (min-width: ${cssBreakpoints.mdUp}) {
    gap: ${pageHeaderRightDesktopGap}px;

    > *:not(:first-child) {
      position: relative;

      &:before {
        content: '';
        position: absolute;
        top: 50%;
        transform: translateY(-50%)
          translateX(-${pageHeaderRightDesktopGap / 2}px);
        width: 1px;
        height: 20px;
        background: ${colors.elementGrey};
        opacity: 0.5;
      }
    }
  }
`;

export const PageHeaderLogoTrackedLink = styled(TrackedLink)`
  display: inline-flex;
  margin-right: 24px;
`;

export const PageHeaderCartPillHolder = styled.div`
  display: flex;
  align-items: center;

  @media (max-width: ${cssBreakpoints.mdDown}) {
    display: none;
  }
`;

export const PageHeaderLoginLink = styled.a`
  padding: 0 4px;
  color: ${colors.mediumContentGrey};
  font-size: inherit;
  transition: color ${transition};

  &,
  &:hover,
  &:focus {
    text-decoration: none;
  }

  &:hover,
  &:focus {
    color: ${colors.brandBlue};
  }
`;

export const PageHeaderLoginHolder = styled.div``;

export const PageHeaderMobileSearchHolder = styled.div`
  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    display: none;
  }
`;

export const PageHeaderMyAccountHolder = styled.div`
  &:before {
    display: none;
  }
`;

export const PageHeaderMobileDonateButtonHolder = styled.div`
  font-size: 16px;
  margin-left: 8px;

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    display: none;
  }

  @media all and (max-width: 380px) {
    display: none;
  }
`;

export const PageHeaderMobileDonateRouterButton = styled(RouterButton)`
  height: 36px;
`;

/**
 * The links are place on top of this `div` using `position: absolute`
 */
export const PageHeaderMobileLinksPlaceholder = styled.div`
  @media all and (max-width: ${cssBreakpoints.mdDown}) {
    height: ${pageHeaderMobileLinksHeight}px;
  }

  @media screen and (min-width: ${cssBreakpoints.mdUp}) {
    display: none;
  }
`;

export const PageHeaderDesktopSearchHolder = styled.div`
  padding: 16px ${gutterWidth / 2}px;
  background-color: ${colors.white};
  border-top: 1px solid ${colors.selectionGrey};

  @media all and (max-width: ${cssBreakpoints.mdDown}) {
    display: none;
  }
`;
